import { render, staticRenderFns } from "./notice-bar.vue?vue&type=template&id=297e65aa&scoped=true&"
import script from "./notice-bar.vue?vue&type=script&lang=js&"
export * from "./notice-bar.vue?vue&type=script&lang=js&"
import style0 from "./notice-bar.vue?vue&type=style&index=0&id=297e65aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e65aa",
  null
  
)

export default component.exports